import { VayuBlocksDevice} from '@vayu-blocks/device-control';
import {BoxControl, RangeControl } from '@wordpress/components';
import { useState} from '@wordpress/element';
import { __ } from '@wordpress/i18n';

export const ImageControl = ({onChange,dataKey,frameData}) => {

    const deviceView  = VayuBlocksDevice();
    const [firstTablet, setFirstTablet] = useState(false);
    const [firstDesktop, setFirstDesktop] = useState(true);

    const setimageborderwidth = (frameData,values) =>{
        const attr = frameData.image.width;
       
        // Ensure border object exists before updating
        const updatedAttributes = {
            ...frameData, // Spread existing frameData
            image: {
                ...frameData.image, 
                width:{
                    ...frameData.image.width,
                    [deviceView]: values,
                }
            },
        };
    
        // Check if it's the first time running on this device view
        const isFirstRun = attr?.[deviceView] === undefined;
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        // Device view specific logic
        if (deviceView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                Object.assign(updatedAttributes.image.width, { Tablet: values, Mobile: values });
                localStorage.setItem('firstTablet', 'true'); // Ensure value is string in localStorage
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (deviceView === 'Tablet') {
            if (isTabletFirstRun) {
                Object.assign(updatedAttributes.image.width, { Mobile: values });
                localStorage.removeItem('firstTablet'); // Reset localStorage item when Tablet is accessed
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            // For other device views, reset tablet/desktop flags
            setFirstTablet(false);
            setFirstDesktop(false);
        }
    
        onChange(dataKey, updatedAttributes); 
    }

    const setimagebordersize = (frameData,values) =>{
        const attr = frameData.image.size;

        // Ensure border object exists before updating
        const updatedAttributes = {
            ...frameData, // Spread existing frameData
            image: {
                ...frameData.image, 
                size:{
                    ...frameData.image.size,
                    [deviceView]: values,
                }
            },
        };
    
        // Check if it's the first time running on this device view
        const isFirstRun = attr?.[deviceView] === undefined;
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        // Device view specific logic
        if (deviceView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                Object.assign(updatedAttributes.image.size, { Tablet: values, Mobile: values });
                localStorage.setItem('firstTablet', 'true'); // Ensure value is string in localStorage
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (deviceView === 'Tablet') {
            if (isTabletFirstRun) {
                Object.assign(updatedAttributes.image.size, { Mobile: values });
                localStorage.removeItem('firstTablet'); // Reset localStorage item when Tablet is accessed
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            // For other device views, reset tablet/desktop flags
            setFirstTablet(false);
            setFirstDesktop(false);
        }
    
        onChange(dataKey, updatedAttributes);
    }

    const setimageborderplace = (frameData,values) =>{
        const attr = frameData.image.place;

        // Ensure border object exists before updating
        const updatedAttributes = {
            ...frameData, // Spread existing frameData
            image: {
                ...frameData.image, 
                place:{
                    ...frameData.image.place,
                    [deviceView]: values,
                }
            },
        };

    
        // Check if it's the first time running on this device view
        const isFirstRun = attr?.[deviceView] === undefined;
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        // Device view specific logic
        if (deviceView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                Object.assign(updatedAttributes.image.place, { Tablet: values, Mobile: values });
                localStorage.setItem('firstTablet', 'true'); // Ensure value is string in localStorage
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (deviceView === 'Tablet') {
            if (isTabletFirstRun) {
                Object.assign(updatedAttributes.image.place, { Mobile: values });
                localStorage.removeItem('firstTablet'); // Reset localStorage item when Tablet is accessed
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            // For other device views, reset tablet/desktop flags
            setFirstTablet(false);
            setFirstDesktop(false);
        }
    
        onChange(dataKey, updatedAttributes); 
    }

    const setimageopacity = (frameData, values) => {
         const updatedAttributes = {
            ...frameData,
            image: {
                ...frameData.image, 
                opacity:values
            },
        };

        onChange(dataKey, updatedAttributes); 
    }

  return (
        <>
           <div className='vayu_blocks_box_control_image'>
                <BoxControl
                    label={__('Width', 'vayu-blocks')}
                    values={frameData.image.width?.[deviceView]}
                    onChange={ ( values ) => setimageborderwidth( frameData, values ) }
                />
            </div>

            <br/>

            <RangeControl
                __nextHasNoMarginBottom
                __next40pxDefaultSize
                label={__('Image Size', 'vayu-blocks')}
                max={100}
                min={0}
                value={frameData.image.size?.[deviceView]}
                onChange={ ( values ) => setimagebordersize( frameData, values ) }
            />

            <RangeControl
                __nextHasNoMarginBottom
                __next40pxDefaultSize
                label={__('Border Place', 'vayu-blocks')}
                max={50}
                min={1}
                value={frameData.image.place?.[deviceView]}
                onChange={ ( values ) => setimageborderplace( frameData, values ) }
            />

            <RangeControl
                __nextHasNoMarginBottom={true}
                __next40pxDefaultSize={true}
                initialPosition={ 0.5 }
                label={__('Opacity','vayu-blocks')}
                max={ 1 }
                min={ 0 }
                step={.1}
                marks
                value={ frameData.image.opacity}
                onChange={ ( values ) => setimageopacity( frameData, values )}
            />
        </>
  )
}
